import { EXPERIMENTS } from '@app/config';
import { useExperiment } from '@app/experiments';
import { useBreakpointValue } from '@stockx/ui';
import useShowWhereAreYou from '@app/shell/AppLayout/components/WhereAreYou/hooks/useShowWhereAreYou';

const useShowLocationSelectorModal = () => {
  const showWhereAreYou = useShowWhereAreYou();
  const { isMobile } = useBreakpointValue();

  const showLocationSelectorModal =
    useExperiment(EXPERIMENTS.ab_mobile_web_location_selector_web) ===
    'control';

  return showWhereAreYou && isMobile && showLocationSelectorModal;
};

export default useShowLocationSelectorModal;
